import React from "react";
import { useTranslation } from "react-i18next";
import { ToolkitItem } from "./catalog";

// Display strings for one item. Experiential items prefer the localized
// experiential.* keys; wip entries without a techniqueKey fall back to the
// catalog's English title (they are stamped wip, tool not available).
export function itemTitle(item: ToolkitItem, t: (k: string) => string): string {
  if (item.kind === "prompt") return item.title;
  return item.techniqueKey ? t(`experiential.techniques.${item.techniqueKey}`) : item.title;
}

export function itemDescription(item: ToolkitItem, t: (k: string) => string): string {
  if (item.kind === "prompt") return item.description;
  return item.techniqueKey ? t(`experiential.techniqueHints.${item.techniqueKey}`) : "";
}

export const TechniqueCard: React.FC<{
  item: ToolkitItem;
  onOpen: (item: ToolkitItem) => void;
}> = ({ item, onOpen }) => {
  const { t } = useTranslation();
  const modality = item.kind === "prompt" ? "transcript" : item.modality;
  return (
    <button type="button" className={`tk-card tk-card--m-${modality}`} onClick={() => onOpen(item)}>
      <span className="tk-card__title">{itemTitle(item, t)}</span>
      <span className="tk-card__desc">{itemDescription(item, t)}</span>
      <span className="tk-card__badges">
        <span className={`tk-badge tk-badge--${item.kind}`}>
          {t(item.kind === "prompt" ? "toolkit.badgeMine" : "toolkit.badgeLibrary")}
        </span>
        <span className={`tk-badge tk-badge--modality tk-badge--m-${modality}`}>{t(`toolkit.modality.${modality}`)}</span>
        {item.kind === "experiential" && item.wip && (
          <span className="tk-badge tk-badge--wip">{t("toolkit.badgeWip")}</span>
        )}
      </span>
    </button>
  );
};
